import { INIT_NOTE_ADD_STATUS } from '@/constants';
import * as dataActions from '@/data/data-actions';
import {
  noteAddStatus as noteAddStatusSelector,
  propertyData as propertyDataSelector,
} from '@/data/data-selectors';
import { toaster } from '@/utils/toaster';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Panel } from 'rsuite';

export const AddNote: React.FC = () => {
  const [note, setNote] = useState<string>('');
  const dispatch = useDispatch();
  const propertyData = useSelector(propertyDataSelector);
  const { inFlight: noteAddInflight, addedNoteId } = useSelector(
    noteAddStatusSelector
  );

  useEffect(
    () => () => {
      // Reset note add status when component unmounts
      dispatch(dataActions.setNoteAddStatus(INIT_NOTE_ADD_STATUS));
    },
    [dispatch]
  );

  const handleNoteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNote(e.target.value);
  };

  useEffect(() => {
    if (addedNoteId && !noteAddInflight) {
      setNote('');
      toaster.success('Note added successfully!');
    }
  }, [addedNoteId, noteAddInflight]);

  const handleAddNote = useCallback(() => {
    if (note.trim()) {
      dispatch(
        dataActions.userAddedNote({
          message: note,
          propertyDeckardID: propertyData?.deckardid,
          licenseTabParam: '',
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [note, propertyData]);

  return (
    <Panel className="mb-5 rounded-lg shadow-md" header="Add Note">
      <textarea
        className="w-full min-h-[150px] p-2.5 border border-gray-200 rounded-md mb-4 resize-none"
        value={note}
        onChange={handleNoteChange}
        placeholder="Enter your note here..."
      />
      <div className="flex justify-between items-baseline">
        <Button
          appearance="primary"
          onClick={handleAddNote}
          className="w-24"
          loading={noteAddInflight}
          disabled={!note.trim()}
        >
          Add
        </Button>
      </div>
    </Panel>
  );
};

export default AddNote;
